export default __webpack_public_path__ + "static/media/home-5.6d434c38.png";